export default "__VITE_ASSET__d2dd458e__"